import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Preloader from './components/Preloader';
import Hero from './sections/Hero';
import Services from './sections/Services';
import Projects from './sections/Projects';
import Testimonials from './sections/Testimonials';
import Contact from './sections/Contact';
import Footer from './sections/Footer';

function App() {
  const [showContent, setShowContent] = useState(false);

  // Replace with your logo image path when available
  const clientLogo = null; // Set to: '/path-to-your-logo.png'

  return (
    <div className="App">
      <Preloader onLoadComplete={() => setShowContent(true)} />
      
      {showContent && (
        <>
          <Navbar logo={clientLogo} />
          <Hero />
          <Services />
          <Projects />
          <Testimonials />
          <Contact />
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
